// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tK-b","controls":"styles_controls__2qRNp","charLimit":"styles_charLimit__21lf-","input":"styles_input__K20g6","send":"styles_send__2tr5c"};